import { connect } from "react-redux";

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var LoadingButton = require("components/utility/LoadingButton");

function showError(message) {
	window.wrNotifications.triggerDropDownNotification({
		title: "Error!", text: message, 
		icon: "exclamation-sign", type: "error" });
}

// require("appdev/crm/new_school_page.scss");

@connect(
	(state, props) => {

		var loading = !!(
			RosterSelectors.isLoadingSchool({ state, key: "create" }) ||
			CRMSelectors.isLoadingContacts({ state, key: "create" })
		)

		return {
			loading
		}

	},
	(dispatch, props) => ({
		createSchool: (school) => {
			return dispatch(
				RosterActions.createSchool({ school })
			).then((response) => {
				var school = (response.schools || [])[0];

				if (!school) {
					showError("No school created!");
					return { success: false };
				}

				if (school.errors) {
					showError(school.errors.join(", "));
					return { success: false };
				}
				
				return { success: true, school };
			});
		},

		createContact: (contact) => {
			return dispatch(
				CRMActions.createContact({ contact })
			).then((response) => {
				var contact = (response.contacts || [])[0];
				
				return { success: true, contact };
			});
		},
	})
)
class NewSchoolPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			name: "",
			type: PUBLIC_TRADITIONAL,
			zip: "",
			
			hierarchyType: DOMESTIC_DISTRICT,
			districtID: "",
			country: "",
			regionID: "",
			
			createdContactID: null
		};
	}
	
	onSubmitSchool(e) {
		$wr.nope(e);
		
		var schoolData = {};

		var contactData = {
			name: this.state.name,
			is_organization: true,
			custom_fields: {
				"Org Level": "School",
				"Org Type": this.state.type
			},
			address: {
				postal_code: this.state.zip
			}
		};

		var error = false;

		["name", "type", "zip"].forEach(k => {
			if (!this.state[k].trim().length) {
				error = true;
				showError("Missing " + k);
			}
			schoolData[k] = this.state[k].trim();
		})

		if (this.state.hierarchyType === DOMESTIC_DISTRICT) {
			if (this.state.districtID) {
				schoolData.district_id = this.state.districtID;
				contactData.district_cs_id = this.state.districtID;
			} else {
				error = true;
				showError("Missing District ID");
			}

		} else if (this.state.hierarchyType === DOMESTIC_INDEPENDENT) {
			if (this.state.regionID) {
				schoolData.direct_parent_region_id = this.state.regionID;
			} else {
				error = true;
				showError("Missing County Region ID");
			}

		} else if (this.state.hierarchyType === INTERNATIONAL) {
			if (this.state.country) {
				contactData.custom_fields["Non-US Country"] = this.state.country;
			} else {
				error = true;
				showError("Missing Country");
			}

		}

		if (error) {
			return
		}
		
		this.props.createSchool(schoolData).then((result) => {
			if (result.success) {
				contactData.custom_fields["Canonical School ID"] = result.school.id;
				
				this.props.createContact(contactData).then((result) => {
					if (result.success) {
						this.setState({ createdContactID: result.contact.id });
					}
				});
			}
		})
	}

	render() {
		if (this.state.createdContactID) {
			var zdsURL = "https://app.futuresimple.com/crm/contacts/" + this.state.createdContactID;
			
			if (this.state.hierarchyType === DOMESTIC_DISTRICT) {
				var placementMessage = (
					<p>
						<strong>Important:</strong> Currently the ZDS API doesn't let me
						put schools into districts. I have support request out to them
						about it. In the meantime, please go to that page and <strong>assign the
						school to the district manually</strong>.
					</p>
				)
			}

			return (
				<div className="newSchoolOrgPage container">
					<header className="pageHeader">
						<h1>Success! New School</h1>
					</header>
					<p>
						<a href={ zdsURL } target="_blank">
							View { this.state.name } on ZDS
						</a>
					</p>
					{ placementMessage }
				</div>
			);
		}
		
		if (this.state.hierarchyType === DOMESTIC_DISTRICT) {
			var dynamicInput = (
				<label className="normal blockLbl">
					District CS ID
					<input className="form-control" value={ this.state.districtID }
						type="number"
						onChange={ e => this.setState({ districtID: e.target.value }) } />
						
					<div className="smallText lightGray">
						Find on <a href="https://schools.whooosreading.org/states">
							canonical schools
						</a> in the URL or as "Canonical District ID" in the ZDS sidebar
					</div>
				</label>
			);
			
		} else if (this.state.hierarchyType === DOMESTIC_INDEPENDENT) {
			var dynamicInput = (
				<label className="normal blockLbl">
					County Region CS ID
					<input className="form-control" value={ this.state.regionID }
						type="number"
						onChange={ e => this.setState({ regionID: e.target.value }) } />
						
					<div className="smallText lightGray">
						Find on <a href="https://schools.whooosreading.org/states">
							canonical schools
						</a> in the URL
					</div>
				</label>
			);

		} else if (this.state.hierarchyType === INTERNATIONAL) {
			var dynamicInput = (
				<label className="normal blockLbl">
					Non-US Country Name
					<input className="form-control" value={ this.state.country }
						onChange={ e => this.setState({ country: e.target.value }) } />
				</label>
			);
		}
		
		return (
			<div className="newSchoolOrgPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>New CS/ZDS School</h1>
					</header>
				</div>
				
				<form onSubmit={ this.onSubmitSchool }>
					<div className="row">
						<div className="col-sm-5">
							<label className="normal blockLbl">
								School Name
								<input className="form-control" value={ this.state.name }
									onChange={ e => this.setState({ name: e.target.value }) } />
							</label>
						</div>
						<div className="col-sm-3">
							<label className="normal blockLbl">
								School Type
								<select className="form-control" value={ this.state.type }
									onChange={ e => this.setState({ type: e.target.value }) }>
									{ SCHOOL_TYPES.map(x => <option value={ x } key={ x }>{ x }</option>) }
								</select>
							</label>
						</div>
						<div className="col-sm-4">
							<label className="normal blockLbl">
								ZIP (00000 if International)
								<input className="form-control" value={ this.state.zip }
									type="text" pattern="[0-9]{5}"
									onChange={ e => this.setState({ zip: e.target.value }) } />
							</label>
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<label className="normal blockLbl">
								Hierarchy Location
								<select className="form-control" value={ this.state.hierarchyType }
									onChange={ e => this.setState({ hierarchyType: e.target.value }) }>
									{ HIERARCHY_OPTIONS.map(x => <option value={ x } key={ x }>{ x }</option>) }
								</select>
							</label>
						</div>
						<div className="col-sm-4">
							{ dynamicInput }
						</div>
					</div>

					<LoadingButton className="btn buttonSuccess" text="Submit"
						onClick={ this.onSubmitSchool }
						loading={ this.props.loading } />
				</form>

			</div>
		);
	}

};

// Creation Types

const DOMESTIC_DISTRICT = "Domestic district school";
const DOMESTIC_INDEPENDENT = "Domestic independent school";
const INTERNATIONAL = "International school";

const HIERARCHY_OPTIONS = [
	DOMESTIC_DISTRICT,
	DOMESTIC_INDEPENDENT,
	INTERNATIONAL
]


// School Types

const PUBLIC_TRADITIONAL = "public traditional"
const PUBLIC_CHARTER = "public charter"
const OTHER_PUBLIC = "other public"
const PRIVATE_INDEPENDENT = "private independent"
const RELIGIOUS = "religious"
const OTHER_PRIVATE = "other private"

const SCHOOL_TYPES = [
	PUBLIC_TRADITIONAL,
	PUBLIC_CHARTER,
	OTHER_PUBLIC,
	PRIVATE_INDEPENDENT,
	RELIGIOUS,
	OTHER_PRIVATE
]


NewSchoolPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	loading: PropTypes.bool,

	// Handlers from @connect
	createSchool: PropTypes.func.isRequired,
	createContact: PropTypes.func.isRequired
});

module.exports = NewSchoolPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/crm/NewSchoolPage.js